import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button']
  
  connect() {
    // Add event listeners to all ping-scan buttons
    document.addEventListener('click', this.handleButtonClick.bind(this))
  }
  
  disconnect() {
    document.removeEventListener('click', this.handleButtonClick.bind(this))
  }
  
  handleButtonClick(event) {
    if (!event.target.closest('.ping-scan-btn')) return
    
    event.preventDefault()
    const button = event.target.closest('.ping-scan-btn')
    this.performPingAndScan(button)
  }
  
  async performPingAndScan(button) {
    const deviceId = button.dataset.deviceId
    const pingUrl = button.dataset.pingUrl
    const scanUrl = button.dataset.scanUrl
    
    // Store original content and disable button
    const originalContent = button.innerHTML
    button.disabled = true
    button.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>'
    
    try {
      console.log(`Starting ping and scan for device ${deviceId}`)
      
      // Start both ping and scan operations in parallel
      const [pingResponse, scanResponse] = await Promise.all([
        fetch(pingUrl, {
          method: 'POST',
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            'X-Requested-With': 'XMLHttpRequest'
          }
        }),
        fetch(scanUrl, {
          method: 'POST',
          headers: {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
      ])
      
      console.log('Ping and scan requests completed')
      
      // Wait for 45 seconds total (operations run in background)
      setTimeout(() => {
        this.restoreButton(button, originalContent)
        this.refreshTableData()
      }, 45000)
      
    } catch (error) {
      console.error('Error during ping and scan:', error)
      this.restoreButton(button, originalContent)
    }
  }
  
  restoreButton(button, originalContent) {
    button.disabled = false
    button.innerHTML = originalContent
  }
  
  refreshTableData() {
    // Trigger table refresh if Bootstrap table is available
    if (window.jQuery && jQuery('#devices-table').length) {
      jQuery('#devices-table').bootstrapTable('refresh')
    }
  }
}